import { NgClass } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    forwardRef,
    inject,
    Input,
    OnInit,
    ViewChild,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RequiredDirective } from "../../directives/required/required.directive";
import { StringFormatPipe } from "../../pipes/string-format.pipe";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { InfoComponent } from "../info/info.component";
import { InputProcessor } from "./input-processor";
import { InputTexts } from "./input.texts";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputComponent)
        },
        {
            multi: false,
            provide: ControlValueAccessorBaseComponent,
            useExisting: forwardRef(() => InputComponent)
        }
    ],
    selector: "rask-input",
    styleUrls: ["./input.component.scss"],
    templateUrl: "./input.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        RequiredDirective,
        InfoComponent,
        FormsModule,
        ValidationMessageComponent,
        StringFormatPipe
    ]
})
export class InputComponent extends ControlValueAccessorBaseComponent implements OnInit {
    @Input() append: boolean;
    @ViewChild("input", { read: ElementRef }) input: ElementRef;
    @Input() inputProcessor: InputProcessor;
    isDisabled: boolean;
    @Input() maxlength?: number;

    @Input() placeholder: string | number = "";
    privateValue: any;
    @Input() readonly: boolean;
    @Input() showmaxlength? = true;
    texts = InputTexts.texts;
    @Input() type: "text" | "password" = "text";
    @Input() updateOn: "change" | "submit" | "blur" = "change";

    protected customValue?: string;

    private readonly cdRef = inject(ChangeDetectorRef);

    onChange: any = () => {
        // Metoden måste finnas, även om den är tom, för att resterande kod ska lira som önskat
    };
    onTouched: any = () => {
        // Metoden måste finnas, även om den är tom, för att resterande kod ska lira som önskat
    };

    get charsLeft(): string | null {
        if (this.maxlength && this.maxlength > 0 && this.value) {
            return (this.maxlength - this.value.length).toString();
        } else if (this.maxlength) {
            return this.maxlength.toString();
        }
        return null;
    }

    @Input() set maxlengthhide(maxLength: number) {
        this.maxlength = maxLength;
        this.showmaxlength = false;
    }

    get showCustomInput() {
        return !!this.inputProcessor;
    }

    customValueChange(value: any) {
        this.value = this.inputProcessor.processInput(value);
        this.cdRef.detectChanges();
        if (this.inputProcessor.useBoundValue) {
            this.customValue = this.inputProcessor.formatOutput(this.value);
        } else {
            this.customValue = this.inputProcessor.formatOutput(value);
        }
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.readonly = this.emptyIsTrue(this.readonly);
    }

    writeValue(value: any): void {
        super.writeValue(value);
        if(this.inputProcessor) {
            this.customValue = this.inputProcessor.formatOutput(value);
        }
    }
}
